import { FiltersByGroup } from "slices/generic-table/thunks/fetchGenericFilters";
import FilterGroup from "./FilterGroup";

interface TableFiltersProps {
  referential: FiltersByGroup[]
  onFilter?: (columnKey: string, value: string) => void
  selectedFiltersByGroup?: Record<string,string[]>
}

const TableFilters: React.FC<TableFiltersProps> = ({ referential }) => {

  return (
    <div className="flex flex-col">
      {
        referential.map((group) =>
          <FilterGroup
            title={group.title}
            items={group.filters}
            showCount={true}
          />
        )
      }
    </div>
  );
};

export default TableFilters;
